import './IconPlay2.css';
import React from 'react';
var IconHeart = function IconHeart(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 12 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 14 : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className, " ").concat(styles),
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 13.714 16"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66",
    d: "M35.23,28.2l-11.294-7a1.363,1.363,0,0,0-.721-.2A1.124,1.124,0,0,0,22,22V36a1.124,1.124,0,0,0,1.215,1,1.361,1.361,0,0,0,.721-.2l11.294-7A.9.9,0,0,0,35.23,28.2Z",
    transform: "translate(-22 -21)"
  }));
};
var styles = "s1t5290";
export default IconHeart;